<template>
  <div class="category-title h-18px text-hex-fff flex items-center justify-between">
    <div class="flex items-center">
      <span class="decoration inline-block w-18px h-18px"></span>
      <span class="ml-10px text-14px font-bold">{{ title }}</span>
    </div>
    <slot name="customerSlot"></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.category-title {
  .decoration {
    background: var(--categoryTitleBg) 0 0 no-repeat;
    background-size: 100% 100%;
    & ~ span {
      letter-spacing: 0.14em;
    }
  }
}
</style>
